import React from "react";
import "./Footer.css";

const Footer = () => (
  <footer className="footer">
    © {new Date().getFullYear()} Carnetados · Desarrollado por Jacob Vila Ferrero
  </footer>
);

export default Footer;
